import './index.css'
import React, { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { Link, Typography } from '@mui/material';
import HandleForm from './HandleForm'
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import { CompanyForm } from '../../models/company.model';
import { createCompany, editCompany, removeCompany } from '../../services/company.service';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { APIResponseModel } from '../../models/api-call';
import useUser from "../../hooks/useUser";
import PrimaryMenuBar from '../CompanyActions/CompanyViewActions';
import ConfirmModal from '../common/ConfirmModal';
import { useNotification } from '../../context/NotificationContext';


interface CompanyCreateFormProps {
  companyForm: CompanyForm;
  company_code? : string;
  setBlockScreen: (p: boolean) => void;
  handleChange: (e: any) => void;
  setSuccessMessage?: (n: any) => void;
  action: string;
}

const CompanyCreateForm: React.FC<CompanyCreateFormProps> = ({
  companyForm,
  company_code = '',
  setBlockScreen,
  handleChange,
  action }) => {
    const navigate = useNavigate()
    const { selectedProject } = useProject()
    const { showNotification } = useNotification()

    const [currentAction, setCurrentAction] = useState<string>(action)
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false)
    const { userAdmin } = useUser()

    const onSubmit: SubmitHandler<CompanyForm> = () => {
      setBlockScreen(true);
      Promise.all([currentAction === 'create' ? createCompany(selectedProject, companyForm) :
        editCompany(selectedProject, company_code, companyForm)]).then(function (results: APIResponseModel[]) {
          showNotification(
          <Typography component='span'>
            <i>Ver Compañía: </i>
            <Link
              sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
              underline='hover'
              href={`/${selectedProject}/company/view/${results[0].data['company_code']}`}
            >
              {results[0].data['company_name']}
            </Link>
        </Typography>)
        setBlockScreen(false);
        navigate("/companies/listing")
      }).catch((error) => {
        showNotification(error.response.data.message, 'error')
        setBlockScreen(false)
      });
    };

  const onSubmitDelete = () => {
    setBlockScreen(true)
    Promise.all([removeCompany(selectedProject, company_code)]).then(function (result: any[]) {
      showNotification(<span>Se ha removido la Compañia: <i>{companyForm.name}</i></span>)
      setOpenConfirmRemoveModal(false)
      setBlockScreen(false)
      navigate('/companies/listing')
    }).catch((error) => {
      setOpenConfirmRemoveModal(false)
      showNotification(error.response.data.message, 'error')
      setBlockScreen(false)
      setTimeout(() => navigate('/companies/listing'), 1500)
    });
  }

  return (
    <React.Fragment>
      {currentAction !== 'create' &&
      
        (<div className='indicators-actions-section'>
            <div className='inidicators-section'>
              <IndicatorChip
                label={`Fecha de creación ${companyForm.created_date}`}
                iconDecoration={<EventAvailableOutlinedIcon />}
              />
            </div>

            <PrimaryMenuBar
              action={currentAction}
              setCurrentAction={setCurrentAction}
              handleRemove={() => setOpenConfirmRemoveModal(true)}
              canEdit={userAdmin}
            />
          </div>)
      }

      <HandleForm
        action={currentAction}
        setBlockScreen={setBlockScreen}
        handleChange={handleChange}
        onSubmit={onSubmit}
        companyForm={companyForm}
        selectedProject={selectedProject}
      />

      <ConfirmModal
        openModal={openConfirmRemoveModal}
        handleCloseModal={() => setOpenConfirmRemoveModal(false)}
        handleConfirm={onSubmitDelete}
      >
        <p>¿ Remover Compañía: {companyForm.name} ?</p>
      </ConfirmModal>

    </React.Fragment>
  );
}

export default CompanyCreateForm;